import * as React from 'react'
import Button from '../components/Button'
import useThunkDispatch from '../common/useThunkDispatch'
import { requestLogOut } from './authActions'

const NoBranches: React.FunctionComponent = () => {
  const dispatch = useThunkDispatch()

  return (
    <div className="replenishment-empty">
      <div className="replenishment-empty_title">User has no branches</div>
      <Button color="primary" onClick={() => dispatch(requestLogOut())}>
        Log out
      </Button>
    </div>
  )
}

export default NoBranches
